module.exports = __webpack_public_path__ + "img/cloudy-night-1.7e65840b.svg";